import { useEffect, useState } from "react";
import { Bot, Cpu, FileImage, UserCog, Tv } from "lucide-react";
import { api } from "@/lib/api";

const Stat = ({ icon: Icon, label, day, month, color, testid }) => (
  <div data-testid={testid} className="flex items-center gap-3 rounded-xl border border-[#1F293D] bg-[#0B1019] px-3 py-2.5">
    <Icon className="h-5 w-5 shrink-0" style={{ color }} />
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="flex items-baseline gap-2">
        <span className="text-xl font-bold text-white">{day}</span>
        <span className="text-xs text-slate-400">hoje · {month} no mês</span>
      </div>
    </div>
  </div>
);

export const BiaCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/bia/stats").then((r) => setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const d = s?.day || {}, m = s?.month || {};

  return (
    <div data-testid="bia-card" className="rounded-2xl border border-[#1F293D] bg-[#111827] p-4">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-pink-500/15"><Bot className="h-5 w-5 text-pink-400" /></span>
        <div>
          <div className="text-sm font-bold text-white">Bia · assistente do chat</div>
          <div className="text-[11px] text-slate-500">Assinaturas conduzidas sozinha (PIX enviado)</div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <Stat testid="bia-stat-assinaturas" icon={Bot} color="#F472B6" label="Assinaturas" day={d.assinaturas ?? "—"} month={m.assinaturas ?? "—"} />
        <Stat testid="bia-stat-prints" icon={FileImage} color="#38BDF8" label="Prints lidos" day={d.prints ?? "—"} month={m.prints ?? "—"} />
        <Stat testid="bia-stat-nao-encontrado" icon={Cpu} color="#FBBF24" label="MAC não achado" day={d.nao_encontrado ?? "—"} month={m.nao_encontrado ?? "—"} />
        <Stat testid="bia-stat-atendente" icon={UserCog} color="#A78BFA" label="Foram p/ atendente" day={d.atendente ?? "—"} month={m.atendente ?? "—"} />
        <Stat testid="bia-stat-apps" icon={Tv} color="#22D3EE" label="Apps configurados" day={d.apps ?? "—"} month={m.apps ?? "—"} />
      </div>
    </div>
  );
};
